import { useState } from "react";
import { styled, AppBar, Toolbar, Typography } from "@mui/material";
import { AccountMenu } from "./AccountMenu";
import { LanguageMenu } from "./LanguageMenu";

interface Props {
  config: string;
  setActionsContainer: (container: Element | null) => void;
}

export function Header(props: Props) {
  const { setActionsContainer, config } = props;
  const [imageStatus, setImageStatus] = useState<"init" | "loaded">("init");

  const title = window._env_.REACT_APP_TITLE || "Mapbase";
  const titleImage = window._env_.REACT_APP_TITLE_IMAGE;

  return render();

  function render() {
    return (
      <Styles>
        <Toolbar>
          {titleImage && (
            <img
              src={titleImage}
              className={`${imageStatus} logo`}
              alt="title logo"
              height="32"
              onLoad={() => setImageStatus("loaded")}
            />
          )}
          <Typography variant="h5" className="title">
            {title}
          </Typography>
          <div
            className="actions-container"
            ref={(ref) => setActionsContainer(ref)}
          ></div>
          <LanguageMenu className="appbar-action" />
          <AccountMenu className="appbar-action" config={config} />
        </Toolbar>
      </Styles>
    );
  }
}

const Styles = styled(AppBar)`
  .MuiToolbar-root {
    padding-right: 0;
    display: flex;
    justify-content: space-between;

    .logo {
      max-height: 32px;
      display: none;
      margin: ${({ theme }) => theme.spacing(0, 2, 0, 0)};

      &.loaded {
        display: block;
      }
    }

    .actions-container {
      margin: ${({ theme }) => theme.spacing(0, 2)};
    }

    .appbar-action {
      align-self: stretch;
      .MuiSvgIcon-root {
        color: ${({ theme }) => theme.palette.common.white};
      }
    }

    & > .title {
      flex-grow: 1;
    }
  }
`;
